<template>
    <div class="d-flex flex-column flex-grow-1">
        <portal to="app-bar">
            <v-tabs
                v-model="tab"
                background-color="primary"
                grow
                slider-color="yellow accent-2"
                slider-size="4"
                center-active
                @change="$vuetify.goTo(0, { duration: 0 })"
            >
                <v-tab
                    v-for="({title, icon}, index) in menu"
                    :key="title"
                    :ref="`tab-${index}`"
                >
                    <v-icon v-if="icon" left small>{{ icon }}</v-icon>
                    {{ title }}
                </v-tab>
            </v-tabs>
        </portal>

        <v-tabs-items v-model="tab" class="flex-grow-1">
            <v-tab-item
                v-for="({title, icon, sections}) in menu"
                :key="title"
            >
                <h2 class="primary--text font-weight-bold px-4 pt-4 pb-2">
                    <v-icon
                        v-if="icon"
                        color="primary"
                        class="mr-1 mb-1"
                        large
                    >{{ icon }}</v-icon>
                    {{ title }}
                </h2>
                <v-list
                    v-for="({title, items}) in sections"
                    :value="sections.length === 1"
                    :key="title"
                    subheader
                >
                    <v-subheader
                        v-if="title"
                        class="primary--text text-h6"
                    >
                        {{ title }}
                    </v-subheader>
                    <template v-for="(item, index) in items">
                        <v-divider :key="`spacer-${index}`" />
                        <v-list-item
                            :key="index"
                            @click="selectMenuItem({id: item.id})"
                            :ripple="{ class: 'primary-background', center: true }"
                        >
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'TheMenu',

  data: () => ({
    tab: null,
  }),

  computed: {
    ...mapState({
      menu: (state) => state.menu.items,
    }),
  },

  created() {
    this.$store.dispatch('getMenu');
  },

  methods: {
    ...mapActions([
      'selectMenuItem',
    ]),
  },
};
</script>

<style lang="scss">

</style>
